import React from "react"
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  DatePicker as MUIDatePicker,
  DatePickerProps as MUIDatePickerProps,
} from "@mui/x-date-pickers/DatePicker"

export type DatePickerProps<T> =
  | ({ new?: false } & MUIDatePickerProps<T>)
  | ({ new: true } & unknown)

export const DatePicker = React.forwardRef<
  HTMLDivElement,
  DatePickerProps<unknown>
>((props, ref) => (props.new ? null : <MUIDatePicker {...props} ref={ref} />))

DatePicker.displayName = "DatePicker"

export default DatePicker
